import { gql } from '@apollo/client';

export const getAllOpenCohortsForUser_Name = 'GetAllOpenCohortsForUser';
export const getAllOpenCohortsForUser_Gql = gql`
  query GetAllOpenCohortsForUser($userId: String!, $status: String!) {
    getAllOpenCohortsForUser(userId: $userId, status: $status) {
      id
      internalLabel
      externalLabel
      startDate
      endDate
      isOngoing
      meetingLink
      archived
      registrationCloseDate
      registrationOpenDate
      preRegistrantsCount
      newRegistrantsCount
      registeredCount
      waitlistCount
      deniedCount
      nextSessionDate
      program {
        name
      }
      developmentUser {
        id
        fullName
        email
      }
      implementationUser {
        id
        fullName
        email
      }
      evaluationUser {
        id
        fullName
        email
      }
      developmentSupportUser {
        id
        firstName
        lastName
      }
      evaluationSupportUser {
        id
        firstName
        lastName
      }
      implementationSupportUser {
        id
        firstName
        lastName
      }
    }
  }
`;
